import {__} from "@wordpress/i18n";
import {SwiperOptions} from "swiper/types";
import Swiper from "swiper";
import {Autoplay} from "swiper/modules";

export const createSwiper = (
	container: HTMLElement|string,
	slideClass: string = 'swiper-slide',
	options: SwiperOptions = {}
): Swiper => {
	const defaults = {
		modules: [
			Autoplay
		],
		a11y: {
			enabled: true,
			prevSlideMessage:                __('Vorheriger Slide', 'dierck-group-theme'),
			nextSlideMessage:                __('Nächster Slide', 'dierck-group-theme'),
			firstSlideMessage:               __('Dies ist der erste Slide', 'dierck-group-theme'),
			lastSlideMessage:                __('Dies ist der letzte Slide', 'dierck-group-theme'),
			paginationBulletMessage:         __('Gehe zu Slide {{index}}', 'dierck-group-theme'),
			slideLabelMessage:               __('{{index}} von {{slidesLength}}', 'dierck-group-theme'),
			containerMessage:                __('Slidekarussell', 'dierck-group-theme'),
			containerRoleDescriptionMessage: __('Karussell', 'dierck-group-theme'),
		},
		allowTouchMove: true,
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		slideClass:        `${slideClass}`,
		slideActiveClass:  `${slideClass}--active`,
		slideBlankClass:   `${slideClass}--blank`,
		slideNextClass:    `${slideClass}--next`,
		slidePrevClass:    `${slideClass}--prev`,
		slideVisibleClass: `${slideClass}--visible`,
	};

	return new Swiper( container, {
		...defaults,
		...options
	} );
};
